import React from "react";
import { ReactElement } from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute: React.FC<{
  element: ReactElement;
  authenticationStatus?: boolean | Object;
}> = ({ element, authenticationStatus = true }) => {

  if (!authenticationStatus) {
    return <Navigate to="/login" />;
  }

  return element;
};

export default ProtectedRoute;
